import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { createHttpLink } from "apollo-link-http"
import { setContext } from "apollo-link-context"
import { onError } from "apollo-link-error"
import { ApolloLink } from "apollo-link"

// This one is defined by webpack's DefinePlugin
// API_HOST should (by now) end with a /
const GRAPHQL_ENDPOINT = `${API_HOST}graphql`

// Session JWT is stored by loginService (REST) under localStorage key "token".
import Auth from "@/auth.js"

// Configure apollo links
const httpLink = createHttpLink({
  uri: GRAPHQL_ENDPOINT,
  credentials: "same-origin"
})

const authLink = setContext((_, { headers }) => {
  // get the authentication token from memory if it exists
  const token = Auth.getToken()
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token ? `JWT ${token}` : ""
    }
  }
})

const client = new ApolloClient({
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors)
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
        )
      if (networkError) console.log(`[Network error]: ${networkError}`)
    }),
    authLink,
    httpLink
  ]),
  cache: new InMemoryCache()
})

export default client
